import React from 'react';
import { BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Information from './pages/Information';
import Contact from './pages/Contact';
import Header from './components/Header';
import './styles/app.css';
import './styles/typography.css';

function AppContent() {

  return (
      <div className="app-container">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/o-nas" element={<About />} />
          <Route path="/informace" element={<Information />} />
          <Route path="/kontakt" element={<Contact />} />
        </Routes>
      </div>
    );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;